<template>
  <div>
    <async-text-field-autocomplete-clients
    v-model="selectableClient"
    class="mt-6"
    label="textFields.clients"
    item-text="name"
    :disabled="disabled"
    @input="add"/>

    <div class="mt-4">
      <span
      v-show="clientsProp.length > 0"
      class="process-repair-tab-section-title"
      style="font-size: 15px;">
        {{$t('textFields.selectedClients')}}
      </span>
      <removable-item
      v-for="({name, fullName}, i) of clientsProp"
      :key="i"
      :label="`${name} (${fullName})`"
      :disabled="disabled"
      @remove="remove(name)"
      />
    </div>    
  </div>
</template>

<script>
import AsyncTextFieldAutocompleteClients from '@/components/text-fields/AsyncTextFieldAutocompleteClients'
import RemovableItem from '@/components/lists/items/RemovableItem'
export default {
  components: {
    AsyncTextFieldAutocompleteClients,
    RemovableItem
  },
  props: {
    clients: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      selectableClient: null
    }
  },
  computed: {
    clientsProp: {
      get: function() {
        return this.$props.clients
      },
      set: function(v) {
        this.$emit("update:clients", v)
      }
    }
  },
  methods: {
    add() {
      const c = this.selectableClient
      if (!c) return
      
      // NOTE: if the array does not include the client, then add it
      if (!this.clientsProp.map(o => o.name).includes(c.name)) {
        this.clientsProp.push({
          name: c.name,
          fullName: `${c.contact.firstName} ${c.contact.lastName}`,
          email: c.contact.email,
          raw: c
        })
      }

      setTimeout(() => this.selectableClient = null, 100)
    },
    remove(name) {
      this.clientsProp = [...this.clientsProp.filter(o => o.name !== name)]
    }
  }
}
</script>

<style>

</style>